import React, { useState, useMemo } from 'react';
import { observer } from 'mobx-react';
import { Card, Tabs } from 'antd';
import { useTranslation } from 'react-i18next';

import { useStores } from '@/hooks/use-stores';
import SlidersHorizontalIcon from '@/comp/common/icons/SlidersHorizontalIcon';
import { EPButton } from '@/components';

import { FilterIconWrapper } from './AlertsSection.styles';
import { Link, useParams } from 'react-router-dom';
import { ALERT_TAB_KEYS } from './AlertsSection.constants';
import { createTabItems, type AlertGroups } from './AlertsSection.utils';

interface AlertsSectionProps {
  deviceId: string;
}

const AlertsSection = observer(({ deviceId }: AlertsSectionProps) => {
  const params = useParams();
  const { t } = useTranslation();
  const { alertStore } = useStores();
  const [activeFilter, setActiveFilter] = useState<string>(ALERT_TAB_KEYS.ALL);
  const allAlerts = alertStore.filterAlertsByDeviceId(deviceId);
  const activeAlerts = alertStore.filterActiveAlerts(allAlerts);
  const archivedAlerts = alertStore.filterArchivedAlerts(allAlerts);

  const alertGroups: AlertGroups = {
    activeAlerts,
    archivedAlerts,
    shutdownAlerts: alertStore.filterShutdownAlerts(activeAlerts),
    warningAlerts: alertStore.filterWarningAlerts(activeAlerts),
    serviceAlerts: alertStore.filterServiceAlerts(activeAlerts),
  };

  const tabItems = useMemo(() => createTabItems(alertGroups, t), [alertGroups, t]);

  return (
    <Card
      title={t('alert')}
      extra={
        <FilterIconWrapper>
          <Link to={`/home/station/${params.stationId}/rules`}>
            <EPButton className="sliders-horizontal-icon" icon={<SlidersHorizontalIcon />} type="text" />
          </Link>
        </FilterIconWrapper>
      }
    >
      <Tabs items={tabItems} activeKey={activeFilter} onChange={setActiveFilter} tabBarGutter={0} />
    </Card>
  );
});

export default AlertsSection;
